<div class="tw-flex tw-justify-between tw-items-center tw-mb-4">
  <div class="tw-flex">
    <h4 class="">{{ 'lang.globals.quotas'|translate }}
      @if (checkPercentage()) {
        <span class="tw-ml-4 tw-text-red-600">
          <!-- <sb-icon icon="attention"></sb-icon> -->
          {{ 'lang.globals.percentageWarning' |translate }}
      </span>
      }
    </h4>
  </div>
  <button sb-button-secondary [icon]="'plus'" [iconButton]="true" [color]="'green'" type="button" (click)="addQuota()"></button>
</div>

<div class="tw-flex tw-gap-1">
  @for (quota of quotas; track quota.id) {
    <sb-comp-single-quota [quota]="quota" [width]="quota.share"></sb-comp-single-quota>
  }
</div>


<sb-table-wrapper-new
  [isInModalContext]="isInModalContext"
  [itemsData]="quotas"
  [loading]="loading()"
  [itemName]="'slots'">

  <!------------------------------

        Table Header

  ------------------------------->
  <ng-template #thead>
    <tr>
      <th>{{ 'lang.globals.name' | translate }}</th>
      <th>{{ 'lang.globals.contentFilter' | translate }}</th>
      <th>{{ 'lang.globals.percentage' | translate }}</th>
      <th class=" sticky-col last-col">
        {{ 'lang.globals.action' | translate }}
      </th>
    </tr>
  </ng-template>
  <!------------------------------

      Table Body

------------------------------->
  <ng-template #tbody let-quota>
    <tr>
      <td>
        <div class="tw-flex">
          <div class="tw-w-15 tw-h-10 tw-border tw-border-solid tw-border-gray-500 tw-rounded tw-mr-2"
               [style.background-color]="'#' + (quota.contentCull?.color??'FFFFFF')"></div>
          <input sbAutofocus
                 *ngIf="autofocusOrderNum == quota.orderNum"
                 type="text" id="Name" class="form-control"
                 [placeholder]="'lang.contentShare.quota.defaultName' | translate" [(ngModel)]="quota.name" />
          <input *ngIf="autofocusOrderNum != quota.orderNum"
                 type="text" id="Name" class="form-control"
                 [placeholder]="'lang.contentShare.quota.defaultName' | translate" [(ngModel)]="quota.name" />
        </div>
      </td>
      <td>
        <button (click)="selectFilter(quota)" type="button" id="Company"
                class="btn btn-hover-primary text-center w-100" [ngClass]="{'btn-hover-primary--active': quota.contentCull}">
          <sb-icon class="mr-1" icon="screenPlay"></sb-icon>
          {{ quota.contentCull ? quota.contentCull?.name : ('lang.globals.contentFilter' |translate) }}
        </button>
      </td>
      <td>
        <div class="tw-flex tw-items-center">
          <input type="number" id="Width" class="form-control tw-text-right tw-w-20" [(ngModel)]="quota.share" min="0" max="100" />
          <span class="tw-text-xl">%</span>
        </div>
      </td>
      <td class="sticky-col last-col">
        <sb-split-button
          [splitButtonItems]="quota.sbButtons ?? []"
          (selectedAction)="resolveSplitButtonAction(quota, $event)"
        ></sb-split-button>
      </td>
  </ng-template>
</sb-table-wrapper-new>

